import React, { PureComponent } from 'react'
import { Keyboard, View, Image, TextInput, Platform } from 'react-native'
import styled from 'styled-components/native'
import KeyboardSpacer from 'react-native-keyboard-spacer'

import { Text } from '../../Atoms/Typography'
import PageHeader from '../../Molecules/PageHeader'
import theme from '../../../styles/theme'
import { thousandSeparator } from '../../../lib/formatters'
import InlineError from '../../Atoms/InlineError'

const Container = styled(View)`
  flex: 1;
  flex-direction: column;
`

const Content = styled(View)`
  flex: 1;
  align-items: flex-end;
  justify-content: flex-start;
  width: 100%;
  height: 100%;
`

const StyledInput = styled(TextInput)`
  height: 40px;
  width: ${Platform.select({ web: '100%', default: '160px' })};
  border-color: ${props => props.editable ? theme.colours.grey : theme.colours.grey};
  background-color: ${props => props.editable ? theme.colours.blue : theme.colours.grey};
  border-width: 2px;
  border-radius: 5px;
  color: ${props => props.editable ? theme.colours.white : theme.colours.black}
  margin: ${theme.gutterUnit}px;
  padding: ${theme.gutterUnit}px;
`

const FieldContainer = styled(View)`
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  ${Platform.select({
    web: `margin-left: ${theme.gutterUnit}px;
    margin-right: ${theme.gutterUnit}px;
    margin-bottom: ${2 * theme.gutterUnit}px;`,
    default: ''
  })}
`

const formatBid = (val, type) => {
  if (type === 1) {
    if (Platform.OS === 'web') {
      return `${(val / 100).toFixed(0)}`
    }
    return `${thousandSeparator((val / 100).toFixed(0))}`
  } else {
    if (Platform.OS === 'web') {
      return `${(val / 100).toFixed(1)}`
    }
    return `${thousandSeparator((val / 100).toFixed(1))}`
  }
}

const formatBidForSending = (val, type) => {
  val = (val || '').replace(/,/i, '')
  if (type === 1) {
    return Number(val).toFixed(0) * 100
  } else {
    return Number(val).toFixed(1) * 100
  }
}
export default class DealRoom extends PureComponent {
  state = {
    bid: null,
    error: null,
    contentWidth: null,
    contentHeight: null
  }

  componentDidMount () {
    this.keyboardDidShowListener = Keyboard.addListener('keyboardDidShow', this._keyboardDidShow)
    this.keyboardDidHideListener = Keyboard.addListener('keyboardDidHide', this._keyboardDidHide)
  }

  componentWillUnmount () {
    this.keyboardDidShowListener.remove()
    this.keyboardDidHideListener.remove()
  }

  _keyboardDidShow = () => {
    this.setState({ error: null })
    this.bid = 0
  }

  _keyboardDidHide = () => {

  }

  handleBlur = () => {
    if (this.state.bid) {
      this.props.onBidChange(this.state.bid)
    }
  }

  onInput = (val) => {
    const bidAsInteger = formatBidForSending(val, this.props.bidType)
    this.setState({ bid: bidAsInteger, error: null })
    if (bidAsInteger !== 0 && !bidAsInteger) {
      return this.setState({ error: 'Invalid Bid: must be whole number' })
    }
    if (this.props.bidType === 1 && bidAsInteger > 1000000) {
      return this.setState({ error: 'Bid must be whole number below 10,000' })
    }
    if (this.props.bidType === 2 && bidAsInteger > 2500) {
      return this.setState({ error: 'Bid must be below 25' })
    }
    this.props.onBidChange(bidAsInteger)
  }

  renderInput () {
    const { bid, bidType, canBid } = this.props
    if (bidType === 1) {
      return (
        <>
          <FieldContainer>
            <StyledInput
              onChangeText={(val) => this.onInput(val)}
              defaultValue={formatBid(bid, bidType)}
              autoCorrect={false}
              underlineColorAndroid='transparent'
              keyboardType='numeric'
              multiline={Platform.OS !== 'web'}
              editable={canBid}
              style={{ textAlign: 'right', fontFamily: 'ubuntu-medium', fontSize: Platform.select({ web: 22, default: 16 }) }}
              onBlur={this.handleBlur}
            />
            <Text medium size={Platform.select({ web: 'l', default: 'm' })} darkgrey>m</Text>
          </FieldContainer>
        </>
      )
    } else {
      return (
        <>
          <FieldContainer>
            <StyledInput
              onChangeText={(val) => this.onInput(val)}
              defaultValue={formatBid(bid, bidType)}
              autoCorrect={false}
              underlineColorAndroid='transparent'
              keyboardType='numeric'
              editable={canBid}
              style={{ textAlign: 'right', fontFamily: 'ubuntu-medium', fontSize: Platform.select({ web: 22, default: 16 }) }}
              // maxLength={8}
            />
            <Text medium size={Platform.select({ web: 'l', default: 'm' })} darkgrey>x</Text>
          </FieldContainer>
        </>
      )
    }
  }

  handleLayout = event => {
    const { width, height } = event.nativeEvent.layout
    if (this.state.contentWidth === width) return // layout was already called

    this.setState({
      contentWidth: width,
      contentHeight: height
    })
  }

  render () {
    return (
      <Container>
        <PageHeader text='DEAL ROOM' />
        {this.state.error && (
          <InlineError message={this.state.error} />
        )}
        <Content onLayout={this.handleLayout}>
          {this.state.contentHeight && (
            <Image
              style={{
                flexGrow: 1,
                width: this.state.contentWidth, // Dimensions.get('window').width - this.props.sidebarWidth,
                height: this.state.contentHeight, // Dimensions.get('window').height - theme.headerHeight - theme.teamBarHeight,
                marginRight: Math.min((this.props.sidebarWidth - 250) / 2, 0),
                resizeMode: 'contain'
              }}
              source={{ uri: this.props.url }}
            />
          )}
          {this.state.contentHeight && (
            <View style={{
              position: 'absolute',
              right: null,
              left: ((this.state.contentWidth - this.props.imageDimensions.width) / 2) + (this.props.imageDimensions.width * 0.777) - 15,
              top: (this.props.imageDimensions.height * 0.126) + ((this.state.contentHeight - this.props.imageDimensions.height) / 2),
              width: (this.props.imageDimensions.width * 0.203) - 10
            }}
            >
              {this.renderInput()}
              <KeyboardSpacer />
            </View>
          )}
        </Content>
      </Container>
    )
  }
}
